import { cabecalhoStyles } from './Cabecalho.style'
import { CabecalhoProps } from './Cabecalho.View'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import msgConstants from '../../../../constants/msgConstants'
import { Parceiro } from '../../../../types/parceiroApiTypes'
import parceiroManager from '../../../../services/api/parceiro/parceiroManager'
import { useForm } from 'react-hook-form'

export function cabecalhoIO({ handleClickMes, handleClickParceiro }: CabecalhoProps) {
  const [abrirModalFiltroParceiros, setAbrirModalFiltroParceiros] = useState(false)
  const [parceiros, setParceiros] = useState<Parceiro[]>([])

  const { control, watch } = useForm<{ meses: 3 | 6 }>({
    defaultValues: {
      meses: 6
    }
  })

  useEffect(() => {
    obterParceirosAtivos()
  }, [])

  const obterParceirosAtivos = async () => {
    await parceiroManager
      .buscarDadosParceiros(true)
      .then((response: Parceiro[]) => {
        setParceiros(response)
      })
      .catch(() => {
        toast.error(msgConstants.USO_GENERICO.erroBusca)
      })
  }

  function handleFecharChip() {
    handleClickParceiro(0)
  }

  const dropDownMes = watch('meses')

  useEffect(() => {
    handleClickMes(dropDownMes)
  }, [dropDownMes])

  return {
    styles: cabecalhoStyles,
    abrirModalFiltroParceiros,
    setAbrirModalFiltroParceiros,
    parceiros,
    handleFecharChip,
    control
  }
}

export type CabecalhoIO = ReturnType<typeof cabecalhoIO>
